
















import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Student } from '@/models/student/student';
import draggable from 'vuedraggable';
import { GPageBase } from '@/mixins';
import { schoolClassChangeModule } from '@/store/modules/frames/school-class-change.module';
import GSchoolClassChangeStudentTile from '@/views/GSchoolClassChange/GSchoolClassChangeStudentTile.vue';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GSchoolClassChangeWorkSpaceDraggable',
  computed: {},
  components: { GSchoolClassChangeStudentTile, draggable },
  methods: {},
})
export default class GSchoolClassChangeWorkSpaceDraggable extends Mixins(GPageBase) {
  noAssignStudents: Student[] = [];

  @Prop({ default: () => {} }) options: any;
  @Prop({ default: (): Student[] => [] }) value: Student[];
  @Watch('value')
  watchData(value: Student[]) {
    this.noAssignStudents = value;
  }

  mounted() {}

  get dragAreaTypeWorkSpace(): GEnum.DragAreaType {
    return GEnum.DragAreaType.TypeWorkSpace;
  }

  get isDragging(): boolean {
    return schoolClassChangeModule.isDragging;
  }

  get studentShowMode(): boolean {
    return schoolClassChangeModule.studentShowMode;
  }

  handleStart(e: any) {
    schoolClassChangeModule.setIsDragging(true);
  }

  handleEnd() {
    schoolClassChangeModule.setIsDragging(false);
  }

  handleAddWorkSpace(e: any) {
    this.noAssignStudents[e.newIndex].dragState = GEnum.DragState.Fixed;
    this.$emit('input', this.noAssignStudents);
  }
}
